import React from 'react';
import Link from 'Components/Link';

import styles from './ExploreCard.scss';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

const ExploreCard = ({
  type,
  id,
  to,
  graphic,
  title,
  body,
  isNew,
  // isDisabled,
}) => {
  return (
    <Link to={to} className={`ExploreCard ExploreCard--${id}`} data-type={type}>
      {isNew && (
        <div className="ExploreCard__corner">
          <ConnectedFormattedMessage id={`model_card.new_label`} />
        </div>
      )}
      <div className="ExploreCard__graphic">{graphic}</div>
      <div className="ExploreCard__text">
        <div className="ExploreCard__title">{title}</div>
        {body}
      </div>
      <div className="ExploreCard__button">
        <ConnectedFormattedMessage id={`model_card.play_cta`} />
      </div>
    </Link>
  );
};

export default ExploreCard;
